module.exports = __webpack_public_path__ + "static/img/adaptivity.dd53340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/OBDUCTION/top/adaptivity.jpg
// module id = K4fC
// module chunks = 0